/**
 * @generated SignedSource<<5bfeae744e81088f6a2ce57e566c5895>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export interface BlockedAccessSubjectInput {
  subjectId: Scalars["ID"]["input"];
  subjectType: BlockedAccessSubjectType;
}
export enum BlockedAccessSubjectType {
  GROUP = "GROUP",
  USER = "USER",
}
export enum ResourceAccessType {
  EDIT = "EDIT",
  VIEW = "VIEW",
}
export type ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation_resolveRestrictionsForSubjects_ResolveRestrictionsPayload_errors_MutationError =
  {
    __typename?: "MutationError";
    message: string | null;
  };
export type ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation_resolveRestrictionsForSubjects_ResolveRestrictionsPayload =
  {
    __typename?: "ResolveRestrictionsPayload";
    success: boolean;
    errors: Array<ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation_resolveRestrictionsForSubjects_ResolveRestrictionsPayload_errors_MutationError>;
  };
export type ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation_Mutation =
  {
    __typename?: "Mutation";
    resolveRestrictionsForSubjects: ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation_resolveRestrictionsForSubjects_ResolveRestrictionsPayload | null;
  };
export type ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutationVariables =
  Exact<{
    accessType: ResourceAccessType;
    contentId: Scalars["Long"]["input"];
    subjects:
      | Array<InputMaybe<BlockedAccessSubjectInput>>
      | InputMaybe<BlockedAccessSubjectInput>;
    spaceRoleId?: InputMaybe<Scalars["ID"]["input"]>;
  }>;
export type ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation =
  ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation_Mutation;
